"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _merge = _interopRequireDefault(require("lodash/merge"));

var _castArray = _interopRequireDefault(require("lodash/castArray"));

var _CrudListItem = require("./CrudListItem.styles");

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Used to display (Read) records while providing Update and Delete functionality.
 * Does not supply Create functionality at this point in time, but 'RudListItem' would have been just a little confusing.
 */
var CrudListItem = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CrudListItem, _React$PureComponent);

  var _super = _createSuper(CrudListItem);

  function CrudListItem(props) {
    var _this;

    _classCallCheck(this, CrudListItem);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setActive", function (isActive) {
      if (isActive !== _this.state.active) {
        _this.setState({
          active: isActive
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "includeRowInfo", function () {
      var _this$props = _this.props,
          itemNumber = _this$props.itemNumber,
          crudButtons = _this$props.crudButtons,
          indicatePrimary = _this$props.indicatePrimary;
      return itemNumber && itemNumber >= 0 || !!crudButtons.find(function (buttonName) {
        return buttonName === 'favorite';
      }) || indicatePrimary;
    });

    _defineProperty(_assertThisInitialized(_this), "buildCrudButtons", function () {
      var _this$props2 = _this.props,
          crudButtons = _this$props2.crudButtons,
          crudButtonConfig = _this$props2.crudButtonConfig,
          disableEdit = _this$props2.disableEdit,
          disableFavorite = _this$props2.disableFavorite,
          disableRemove = _this$props2.disableRemove;
      var disableMap = {
        edit: disableEdit,
        favorite: disableFavorite,
        remove: disableRemove
      };
      var buttonConfig = (0, _merge.default)(CrudListItem.defaultCrudButtonConfig, crudButtonConfig);
      return crudButtons.map(function (buttonName) {
        var itemConfig = buttonConfig[buttonName];
        return /*#__PURE__*/_react.default.createElement(_CrudListItem.CrudButton, {
          dataTestId: "generic-details-list-item-".concat(buttonName, "-crud-button"),
          key: "".concat(buttonName, "-crud-button"),
          activeButtonColor: itemConfig.activeColor,
          buttonColor: itemConfig.color,
          disabled: disableMap[buttonName],
          onClick: function onClick() {
            return _this.handleCrudButtonClick(buttonName);
          }
        }, /*#__PURE__*/_react.default.createElement(_CrudListItem.StyledIcon, {
          dataTestId: "generic-details-list-item-crud-button-icon",
          iconName: itemConfig.icon,
          colorTheme: "overDark"
        }), /*#__PURE__*/_react.default.createElement(_CrudListItem.ButtonText, {
          dataTestId: "generic-details-list-item-crud-button-text"
        }, itemConfig.text));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCrudButtonClick", function (action) {
      var _this$props3 = _this.props,
          itemId = _this$props3.itemId,
          crudClickHandler = _this$props3.crudClickHandler;
      return crudClickHandler(action, itemId);
    });

    _defineProperty(_assertThisInitialized(_this), "buildBodyText", function () {
      var bodyText = _this.props.bodyText;

      if (!bodyText || !bodyText.length) {
        return undefined;
      }

      var bodyTextArray = (0, _castArray.default)(bodyText);
      return bodyTextArray.map(function (text) {
        return /*#__PURE__*/_react.default.createElement(_CrudListItem.StyledBodyText, {
          key: "body-text-block-".concat(text.substr(0, 10)),
          dataTestId: "card-text-block-body-text"
        }, text);
      });
    });

    _this.state = {
      active: false,
      renderedButtons: _this.buildCrudButtons(),
      includeRowInfo: _this.includeRowInfo()
    };
    return _this;
  }

  _createClass(CrudListItem, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!(0, _isEqual.default)(prevProps, this.props)) {
        this.setState({
          renderedButtons: this.buildCrudButtons(),
          includeRowInfo: this.includeRowInfo()
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          _inStyleGuide = _this$props4._inStyleGuide,
          bodyText = _this$props4.bodyText,
          dataTestId = _this$props4.dataTestId,
          headerText = _this$props4.headerText,
          isPrimary = _this$props4.isPrimary,
          itemNumber = _this$props4.itemNumber,
          readOnly = _this$props4.readOnly;
      var _this$state = this.state,
          active = _this$state.active,
          renderedButtons = _this$state.renderedButtons,
          includeRowInfo = _this$state.includeRowInfo;
      return /*#__PURE__*/_react.default.createElement(_CrudListItem.ListItemContainer, {
        _inStyleGuide: _inStyleGuide,
        dataTestId: dataTestId
      }, /*#__PURE__*/_react.default.createElement(_CrudListItem.ListItem, {
        dataTestId: "generic-details-list-item-list-item",
        active: active,
        crudButtonCount: renderedButtons.length
      }, /*#__PURE__*/_react.default.createElement(_CrudListItem.TextContainer, {
        dataTestId: "generic-details-list-item-text-container",
        active: active,
        crudButtonCount: renderedButtons.length,
        onClick: function onClick() {
          return _this2.setActive(false);
        }
      }, includeRowInfo && /*#__PURE__*/_react.default.createElement(_CrudListItem.RowInfoContainer, null, isPrimary && /*#__PURE__*/_react.default.createElement(_CrudListItem.PrimaryIndicatorContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        dataTestId: "generic-details-list-item-primary-indicator",
        iconName: "star",
        size: "smallLarge",
        colorTheme: "primary"
      })), itemNumber >= 0 && /*#__PURE__*/_react.default.createElement(_CrudListItem.ItemNumberContainer, null, /*#__PURE__*/_react.default.createElement(_CrudListItem.ItemNumberText, {
        dataTestId: "generic-details-list-item-index-indicator",
        isPrimary: isPrimary
      }, itemNumber))), /*#__PURE__*/_react.default.createElement(_CrudListItem.StyledTextBlock, {
        dataTestId: "generic-details-list-item-text-display-block"
      }, !!headerText && /*#__PURE__*/_react.default.createElement(_CrudListItem.StyledHeader, {
        dataTestId: "card-text-block-header-text"
      }, headerText), this.buildBodyText(bodyText)), !readOnly && /*#__PURE__*/_react.default.createElement(_CrudListItem.StyledIconButton, {
        active: active,
        dataTestId: "generic-details-list-item-button-toggle",
        onClick: function onClick() {
          return _this2.setActive(true);
        },
        iconName: "ellipsis-v"
      })), /*#__PURE__*/_react.default.createElement(_CrudListItem.ButtonContainer, {
        dataTestId: "generic-details-list-item-button-container"
      }, renderedButtons)));
    }
  }]);

  return CrudListItem;
}(_react.default.PureComponent);

_defineProperty(CrudListItem, "propTypes", {
  /** Styleguide toggle for adjusting styling */
  _inStyleGuide: _propTypes.default.bool,

  /** Low weight text for the card that appears below the header text. Takes strings, or an array of strings */
  bodyText: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),

  /** Optional override for default button configuration (e.g. text, colors, icon) */
  crudButtonConfig: _propTypes.default.shape({}),

  /**
   * Buttons to include on the row.
   *
   * Takes an array of button names with three possibilities:
   *  [
   *    'edit',
   *    'favorite',
   *    'remove',
   *  ]
   */
  crudButtons: _propTypes.default.arrayOf(_propTypes.default.string),

  /** Click handler for all crud buttons. Returns action type and itemId */
  crudClickHandler: _propTypes.default.func.isRequired,

  /** Testing hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Disables Edit button */
  disableEdit: _propTypes.default.bool,

  /** Disables Favorite/Primary button */
  disableFavorite: _propTypes.default.bool,

  /** Disables Remove button */
  disableRemove: _propTypes.default.bool,

  /** Bolder header text for the card. Takes only a string */
  headerText: _propTypes.default.string,

  /** ID for the represented entity */
  itemId: _propTypes.default.string.isRequired,

  /** Denotes whether item is primary and will add an additional icon if the item itself is primary */
  isPrimary: _propTypes.default.bool,

  /** On enumerated lists, this will be the index number */
  itemNumber: _propTypes.default.number,

  /** Bool toggle that will show or not show the primary indicator (keeps/removes the primary/number gutter) */
  indicatePrimary: _propTypes.default.bool,

  /** Will remove the crud button toggle and behavior */
  readOnly: _propTypes.default.bool
});

_defineProperty(CrudListItem, "defaultProps", {
  _inStyleGuide: false,
  bodyText: [],
  crudButtonConfig: undefined,
  crudButtons: ['edit', 'remove'],
  disableEdit: false,
  disableFavorite: false,
  disableRemove: false,
  headerText: undefined,
  indicatePrimary: false,
  isPrimary: false,
  itemNumber: -1,
  readOnly: false
});

_defineProperty(CrudListItem, "defaultCrudButtonConfig", {
  edit: {
    color: 'c_clickable_primary_background',
    activeColor: 'c_clickable_primary_active_background',
    icon: 'pencil-alt',
    text: 'Edit'
  },
  favorite: {
    color: 'accessibleAqua',
    activeColor: 'accessibleAquaHover',
    icon: 'star',
    text: 'Primary'
  },
  remove: {
    color: 'c_clickable_primary_background',
    activeColor: 'c_clickable_primary_active_background',
    icon: 'trash',
    text: 'Remove'
  }
});

var _default = CrudListItem;
exports.default = _default;